var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tag',{class:_vm.getStateInfo(_vm.progressName).color},[_c('b-icon',{attrs:{"icon":_vm.getStateInfo(_vm.progressName).icon}}),_vm._v("\n  "+_vm._s(_vm.progressName)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }